export default __webpack_public_path__ + "static/media/Windsor_Light_Condensed.2feb4408.ttf";